import getConfig from 'next/config';
import { slasCallbackEndpoint } from '~/features/commerce-api/auth';
import { PaymentResponseCode, transactionKeys } from '~/lib/data-contract/payment';

const { publicRuntimeConfig } = getConfig() || {};

export const createSlasCallbackUrl = (config: {
    orderNo: string | undefined;
    responseCode: keyof typeof PaymentResponseCode;
    absolute?: boolean;
}) => {
    const { orderNo, responseCode, absolute } = config;

    const path = `${slasCallbackEndpoint}?${transactionKeys.orderNo}=${orderNo}&${transactionKeys.responseCode}=${PaymentResponseCode[responseCode]}`;

    return absolute ? new URL(path, publicRuntimeConfig.NEXT_PUBLIC_URL).toString() : path;
};
